import { getStorage } from '@/utils/storage'
import Bridge from 'lib/lib/Bridge'
import { getPlatform } from 'lib/tools/getPlatform'
import { versionfunegt } from 'lib/tools/utils'

export const getToken = () => {
  let userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
  if (userInfo) {
    return userInfo.token
  }
}

export const getUserId = () => {
  let userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
  if (userInfo) {
    if (userInfo.userId) return userInfo.userId
    if (userInfo.data && userInfo.data.base) return userInfo.data.base.user_id || ''
  }
  return ''
}

export const getOpenId = () => {
  return getStorage('live-userInfo-open_id')
}

/*处理阿里云播放器*/
export const aliplayerReadyHandle = () => {
  const ua = navigator.userAgent.toLocaleLowerCase()
  const video = document.querySelector('video')
  if (!video) return
  // x5内核
  if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
    video.removeAttribute('x5-playsinline') // 如果开启了playsinline=true，这里需要移除，对直播无效
    // video.setAttribute('x-webkit-airplay', true);
    // video.setAttribute('x5-playsinline', true);
    // video.setAttribute('webkit-playsinline', true);
    // video.setAttribute('playsinline', true);
    // x5内核 启用同层H5播放器（会有黑屏缓冲问题）
    video.setAttribute('x5-video-player-type', 'h5-page');
    video.setAttribute('x5-video-player-fullscreen', true);
  } else {
    // ios端
    video.setAttribute('webkit-playsinline', true);
    video.setAttribute('playsinline', true);
  }
}

export const isWifi = () => {
  let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || { type: 'unknown' };
  let ua = navigator.userAgent.toLocaleLowerCase();
  let network = 'unknow'

  // 如果是微信
  if(/micromessenger/.test(ua)){
    // 如果是微信6.0以上版本，用UA来判断
    if(/nettype/.test(ua)){
      var type = ua.match(/nettype\/(\S*)/);
      network = type[1];
    }else{
      // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
      document.addEventListener("WeixinJSBridgeReady",() => {
        WeixinJSBridge.invoke('getNetworkType',{},(e) => {
          network = e.subtype;
        });
      });
    }
  }else if(connection){ // 如果支持navigator.connection
    network = connection.type;
  }
  if (network && network.indexOf('wifi') !== -1) {
    return true
  } else {
    return false
  }
}

/*将时间转换成年、月、日、时、分、秒返回*/
export const timeSplit = (date) => {
  if (date) {
    let year = new Date(date.replace(/-/g, '/')).getFullYear()
    let month = new Date(date.replace(/-/g, '/')).getMonth() + 1
    month = month.toFixed(0).padStart(2, '0')
    const day = new Date(date.replace(/-/g, '/')).getDate().toFixed(0).padStart(2, '0')
    const hour = new Date(date.replace(/-/g, '/')).getHours().toFixed(0).padStart(2, '0')
    const min = new Date(date.replace(/-/g, '/')).getMinutes().toFixed(0).padStart(2, '0')
    const sec = new Date(date.replace(/-/g, '/')).getSeconds().toFixed(0).padStart(2, '0')
    return {
      year,
      month,
      day,
      hour,
      min,
      sec
    }
  } else {
    return {
      year: '00',
      month: '00',
      day: '00',
      hour: '00',
      min: '00',
      sec: '00'
    }
  }
}

/*控制数字小数点位数*/
export const formatDecimal = (num, decimal) => {
  num = num.toString()
  let index = num.indexOf('.')
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1)
  } else {
    num = num.substring(0)
  }
  return parseFloat(num).toFixed(decimal)
}

/*算金钱，分转成元*/
export const centToYuan = (money) => {
  return (money/100).toFixed(2)
}

export const isApp = (userAgent = navigator.userAgent) => /(?:yixinliApp)/.test(userAgent)

// 显示/隐藏页面的标题栏
export function switchNavigationBar (isHidden = 0) {
  if (isApp()) {
    let callMethod = 'switchTitleBar'
    const { yixinliAPPVersion } = getPlatform()
    if (versionfunegt(yixinliAPPVersion, '6.8.0')) {
      callMethod = 'switchNavigationBar'
    }
    new Bridge().call(callMethod, {
      isHidden
    })
  }
}

/**
 * 将字符串数字，转化为number
 * @param {object} data
 */
export function toNumbers (data) {
  const result = {}
  Object.keys(data).forEach(key => {
    const val = data[key]
    const num = typeof val === 'number' ? val : Number(val)
    result[key] = isNaN(num) ? val : num
  })
  return result
}

// 定时器
export function wait (time) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), time)
  })
}
